export default __webpack_public_path__ + "static/media/WhiteColorDeleteIcon.fca42326.svg";